import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import './AccentPicker.scss';

class AccentPicker extends BaseComponent {

  constructor(props) {
    super(props);
    this.color = this.props ? this.props.companyAccent : '';
    this.setColor = this.setColor.bind(this);
  }

  setColor(color) {
    if(color == this.color){
      this.color = null;
      this.props.setCompanyAccent(null);
    }
    else{
      this.color = color;
      this.props.setCompanyAccent(color);
    }
  }

  render() {
    const { companyAccent } = this.props;
    this.color = companyAccent ? companyAccent : null;
    let accent = this.color ? this.color : null;

    let colorArray = ['#001C2C','#00395A','#005586','#007FC8','#00A2FF','#4E0002','#8D0004','#AF0006','#CD030A','#F20008',
                    '#6E4400','#B67100','#C87C00','#E99100','#FF9F00','#004E28','#00743C','#00904A','#00A354','#00D06C'];

    let selectStyle = { border: 'white 1px solid' };
    let colors = colorArray.map((color) => {
      let style = { 
        backgroundColor: color,
      };
      if (color == accent){
        let selectStyle = { 
          border: color +  ' 1px solid',
        };
        return (
          <div key={color} className="accent-outline" style={selectStyle}>
            <div  className={'accent-color'} style={style} onClick={ () => this.setColor(color) }></div>
          </div>
        );
      }

      return (
        <div key={color} className="accent-outline" style={selectStyle}>
          <div  className={'accent-color'} style={style} onClick={ () => this.setColor(color) }></div>
        </div>
      );
    });
    return (
      // Replace with the appropriate HTML
      <div className="accent-picker-container">
        <div className="accent-colors-container">
          {colors}
        </div>
        <div className="accent-instructions">{'Select a color swatch to set your Accent Theme Color'}</div>
      </div>
    );
  }
}

export default (AccentPicker);



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/AccentPicker/index.js